import { FC } from 'react';
import { cn } from '../lib';
import { useRTL } from '../hooks';
import { Typography } from './Typography';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '../shadcn';

export interface SelectorVariantType {
  value: string;
  title: string;
  image?: string;
}

interface SelectorProps {
  value: string;
  disabled?: boolean;
  placeholder?: string;
  defaultOpen?: boolean;
  onOpenChange?: VoidFunction;
  variants: SelectorVariantType[];
  onChange?: (val: string) => void;
  className?: string;
  selectorClassName?: string;
  selectContentClassName?: string;
  variantClassName?: string;
  disabledIcon?: boolean;
}

export const Selector: FC<SelectorProps> = ({
  value,
  onChange,
  variants,
  placeholder,
  onOpenChange,
  disabled = false,
  defaultOpen = false,
  className,
  variantClassName,
  selectorClassName,
  selectContentClassName,
  disabledIcon = false,
}) => {
  const isRTL = useRTL();

  return (
    <div className={cn(className, 'flex flex-col gap-1 min-w-[130px]')}>
      <Select
        value={value}
        disabled={disabled}
        defaultOpen={defaultOpen}
        onOpenChange={onOpenChange}
        onValueChange={(val) => onChange?.(val)}
      >
        <SelectTrigger className={cn('w-full', selectorClassName)} disabledIcon={disabledIcon}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>

        <SelectContent
          className={cn(
            'bg-background w-[var(--radix-select-trigger-width)]',
            isRTL && 'text-right',
            selectContentClassName,
          )}
        >
          <SelectGroup>
            {variants.map((variant) => (
              <SelectItem key={variant.value} value={variant.value} className={cn('px-4', variantClassName)}>
                <div className='flex items-center gap-[6px]'>
                  {variant.image && <img src={variant.image} width={16} height={16} alt={variant.image} />}
                  <Typography variant='subtitle1'>{variant.title}</Typography>
                </div>
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};
